var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"CS logo","src":require("../assets/cs_logo.png")}}),_c('HelloWorld',{attrs:{"id":"hw1"}}),_c('About',{attrs:{"id":"about"}}),_c('Contact',{attrs:{"id":"contact"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }